import type { I18nLangsVO } from '@/types';
import { createContext, useContext } from 'react';

export interface BusinessLanguagesState {
  /** 加载中为 null；读失败后是内置三语（provider 已回退） */
  languages: I18nLangsVO | null;
  loading: boolean;
  reload: () => Promise<void>;
}

export const BusinessLanguagesContext =
  createContext<BusinessLanguagesState | null>(null);

/** 所有业务名称与语言提示共用当前后台会话的语言事实。 */
export function useBusinessLanguages() {
  const value = useContext(BusinessLanguagesContext);
  if (!value) throw new Error('BusinessLanguagesProvider 尚未挂载');
  return value;
}
